// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1yJkS","filesListContainer":"PosDisputesFiles_filesListContainer__2GkAF","filesButton":"PosDisputesFiles_filesButton__2WqMs"};